/* eslint-disable @typescript-eslint/no-namespace */

import { BusinessServices, ITeam } from '@shs-digi-care-monorepo/interfaces';
import { UpdateTeam } from '../../services';

export namespace TeamActions {
    /**
     * Loads all teams for all business services.
     * This should be dispatched once during app initialization.
     */
    export class LoadAll {
        public static readonly type = '[Team] Load All';
    }

    /**
     * Loads teams for a specific business service.
     */
    export class LoadByStream {
        public static readonly type = '[Team] Load By Stream';
        constructor(public businessService: BusinessServices) {}
    }

    /**
     * Sets the teams in the store (used after API response).
     */
    export class SetTeams {
        public static readonly type = '[Team] Set Teams';
        constructor(public teams: ITeam[]) {}
    }

    /**
     * Appends teams to the existing list without duplicates.
     */
    export class AppendTeams {
        public static readonly type = '[Team] Append Teams';
        constructor(public teams: ITeam[]) {}
    }

    /**
     * Updates a team via API and refreshes the store.
     */
    export class Update {
        public static readonly type = '[Team] Update';
        constructor(
            public id: string,
            public payload: UpdateTeam
        ) {}
    }

    /**
     * Clears all teams from the store.
     */
    export class Clear {
        public static readonly type = '[Team] Clear';
    }
}
